import React from 'react'

import { Box } from '@domain-group/suit-theme'

interface SquareIconWithBackgroundProps {
  backgroundColor: string,
  children: React.ReactNode,
  color?: string,
  height?: number | string,
  width?: number | string,
}

const SquareIconWithBackground = (props: SquareIconWithBackgroundProps) => {
  const {
    backgroundColor, children, color, height, width,
  } = props

  return (
    <Box
      alignItems="center"
      backgroundColor={backgroundColor}
      borderRadius={5}
      color={color}
      height={height || 40}
      justifyContent="center"
      width={width || 40}
    >
      {children}
    </Box>
  )
}

export default SquareIconWithBackground
